define('paychex.app.messages/panel/MessageListPanelController',[
    'angular',
    'jquery',
    'lodash',
    'paychex.topics.common',
    'paychex.framework.angular.ui2/UI2EventTopics',
    'paychex.core/Tracker'
],
    function (angular,
              $,
              _,
              eventTopics,
              UI2EventTopics,
              Tracker) {

        'use strict';

        var ngDependencies = [
                '$q',
                'ListPanelManager',
                'DrawerManager',
                'MessageListDataService',
                'MessageListModelService',
                'EventingService',
                'TranslationService',
                'GlobalStateService',
                '$timeout',
                '$scope'
            ],
            // TODO: Should this subclass the controller base in order to inherit lifecycle events?
            Constructor = function ($q,
                                    ListPanelManager,
                                    DrawerManager,
                                    MessageListDataService,
                                    MessageListModelService,
                                    EventingService,
                                    TranslationService,
                                    GlobalStateService,
                                    $timeout,
                                    $scope) {

                // TODO: move these topics to common?
                var accordionTopics = UI2EventTopics,
                    self = this,
                    lifecycle = {id: 'paychex.app.panel.messageList'},
                    Constants = {
                        NAMESPACE: 'paychex.app.landing.shared.messageList.MessageListPanelController',
                        PANEL: {
                            SLIDEOUT_ID: 'listPanel',
                            PANEL_ID: 'paychex.app.panel.messageList'
                        },
                        DRAWER: {
                            DRAWER_ID: 'paychex.app.drawer.messageDrawer',
                            DRAWER_ELEMENT_ID: 'listPanelDrawer'
                        },
                        CHECKBOX_STATES: {
                            NONE: 'none',
                            SOME: 'some',
                            ALL: 'all'
                        },
                        GENERAL_ID: '_GENERAL_',
                        GENERAL_DISPLAY_NAME: 'General',
                        ACCORDION_ID: 'paychex.app.landing.shared.messageList.accordion',
                        VALID_SORT_PROPERTIES: ['date', 'priority', 'from', 'readStatus', 'subject'],
                        DEFAULT_SORT_VALUES: ['date', 'priority', 'from', 'subject'],
                        MESSAGE_LIST: 'Message List',
                        CATEGORY: 'Messages'
                    },
                    internal,
                    // prevent us from incorrectly sending 'sort' tracking events to GA/Splunk during a refresh
                    allowSendSortEvent = true,
                    isLoaded = false,
                    updateByCount = function updateByCount(messageCount) {
                        // if model is undefined, disable buttons
                        if (self.MessageListModel.model === undefined || messageCount === 0) {
                            self.buttonStates.selectEnabled = self.buttonStates.sortEnabled = false;
                        } else {
                            // enable select and sort if the messageCount is greater than 0
                            self.buttonStates.selectEnabled = self.buttonStates.sortEnabled = (MessageListModelService.getActiveGroup() !== null && MessageListModelService.getActiveGroup().messageList.getSize() > 0);
                        }
                    };

                self.generalId = Constants.GENERAL_ID;
                self.accordionId = Constants.ACCORDION_ID;
                self.sortOptions = {
                    order: -1,
                    properties: Constants.DEFAULT_SORT_VALUES
                };

                internal = {
                    // will hold EventingService subscriptions to cancel on cleanup
                    subscriptions: {},

                    watchers: [],

                    // now that we're not using a real pngCheckbox for our top-level checkbox,
                    // we can end up in a weird situation where setting the top-level check status
                    // doesn't update the "child" checkboxes. this ensures everything matches
                    updateListPanelCheckboxes: function updateListPanelCheckboxes() {
                        if (self.globalCheckboxState === Constants.CHECKBOX_STATES.SOME) {
                            return;
                        }
                        var checked = self.globalCheckboxState !== Constants.CHECKBOX_STATES.NONE;
                        _(_.get(self.MessageListModel.getActiveGroup(), 'messageList', {getItems: _.constant([])})
                            .getItems())
                            .filter(function needsUpdating(item) {
                                return item.checked !== checked;
                            })
                            .forEach(function updateStatus(item) {
                                item.checked = checked;
                            });
                    },

                    updateButtonStates: function updateButtonStates(config) {
                        if (self.isLoaded === false) {
                            self.buttonStates.showRefresh = true;
                            self.buttonStates.deleteEnabled = false;
                            self.buttonStates.refreshEnabled = false;
                            self.buttonStates.moreEnabled = false;
                            self.buttonStates.selectEnabled = self.buttonStates.sortEnabled = false;
                        } else {
                            self.buttonStates.refreshEnabled = true;

                            var newCheckboxState = config.newCheckboxState,
                                messageCount = config.messageCount;

                            if (newCheckboxState === Constants.CHECKBOX_STATES.NONE || messageCount === 0) {
                                self.buttonStates.deleteEnabled = false;
                                self.buttonStates.showRefresh = true;
                                self.buttonStates.refreshEnabled = true;
                                self.buttonStates.moreEnabled = false;
                            } else if (newCheckboxState === Constants.CHECKBOX_STATES.SOME || newCheckboxState === Constants.CHECKBOX_STATES.ALL) {
                                self.buttonStates.deleteEnabled = true;
                                self.buttonStates.showRefresh = false;
                                self.buttonStates.refreshEnabled = false;
                                self.buttonStates.moreEnabled = true;
                            }
                            self.allChecked = newCheckboxState === Constants.CHECKBOX_STATES.ALL;
                            updateByCount(messageCount);
                        }
                        self.globalCheckboxState = config.newCheckboxState || Constants.CHECKBOX_STATES.NONE;
                        internal.updateListPanelCheckboxes();
                    },
                    sendMessageToDrawer: function sendMessageToDrawer() {
                        DrawerManager.openDrawer(
                            Constants.DRAWER.DRAWER_ID,
                            DrawerManager.constants.drawerDirectiveIds.LIST_PANEL_DRAWER
                        ).done();
                    },

                    selectInitialShade: function selectInitialShade(state, model) {
                        var group = null,
                            selectedClient,
                            initialSelected;

                        selectedClient = state.clients[0]._clientPlatformGroup.displayId;

                        // Changed to 1 for length to start checking from client rather than General.
                        // this makes else work too.
                        initialSelected = _.some(model, function selectInitial(client) {
                            return client.clientId === selectedClient && (group = client);
                        });
                        if (model.length === 1 || !initialSelected) {
                            group = model[0];
                        }

                        internal.updateActiveGroup(group);
                        Tracker.marks.measure('Message List Panel Requested to DOM Loaded',
                            'Start: List Panel [paychex.app.panel.messageList]: Open', undefined,
                            {
                                category: Constants.MESSAGE_LIST,
                                tags: ['open', 'load', 'messages']
                            }
                        );

                    },
                    updateActiveGroup: function updateActiveGroup(group) {
                        var newGroup = group ? MessageListModelService.getMessageGroupById(group.clientId) : group;
                        MessageListModelService.setActiveGroup(newGroup);

                        self.activeGroupId = newGroup ? newGroup.clientId : null;
                        internal.updateActiveShade(group);
                        internal.updateButtonStates({
                            newCheckboxState: 'none',
                            messageCount: newGroup ? newGroup.messageList.getSize() : 0
                        });
                    },
                    updateActiveShade: function updateActiveShade(group) {
                        if (!_.isNil(group)) {
                            $timeout(function delay() { // we need it to wait for setActive digest cycle to be completed
                                self.activeGroupId = group ? group.clientId : null;
                                EventingService.announce(Constants.NAMESPACE, accordionTopics.PNG_UI_ACCORDION_REQUEST_OPEN, {
                                    itemId: group.clientId,
                                    accordionId: self.accordionId
                                });
                            });
                        } else {
                            EventingService.announce(Constants.NAMESPACE, accordionTopics.PNG_UI_ACCORDION_REQUEST_CLOSE_ALL, {accordionId: self.accordionId});
                        }
                    },
                    sortMessages: function sortMessages() {
                        var capitalized = self.sortOptions.properties[0].charAt(0).toUpperCase() + self.sortOptions.properties[0].slice(1);
                        MessageListModelService.sortMessages(self.sortOptions.properties, self.sortOptions.order);
                        if (allowSendSortEvent) {
                            Tracker.events.fire('Sort', {
                                category: Constants.CATEGORY,
                                label: capitalized + (self.sortOptions.order === 1 ? ' Ascending' : ' Descending'),
                                dimension32: Constants.MESSAGE_LIST
                            });
                        }
                    },
                    unload: function unload() {
                        _.forEach(internal.watchers, function cleanUpWatchers(watcher) {
                            watcher();
                        });

                        _.forOwn(internal.subscriptions, function unregister(sub) {
                            sub.unregister && sub.unregister() || sub();
                        });
                    },
                    clear: function clear(event) {
                        // The if() condition is to determine the origin of the event; if event was triggered in MessageListPanel then execute.
                        if (event.payload.panelId === Constants.PANEL.PANEL_ID) {
                            self.setActiveMessage();
                            self.selectByStatus();
                        }
                    }
                };

                self.setActiveGroup = function setActiveGroup(group, $event) {
                    // avoid issues with the accordion by catching the event and stopping it from bubbling
                    $event.stopImmediatePropagation();
                    $event.preventDefault();

                    if (MessageListModelService.getActiveGroup() === MessageListModelService.getMessageGroupById(group.clientId)) {
                        internal.updateActiveGroup(null);
                    } else {
                        internal.updateActiveGroup(group);
                    }
                };

                self.setActiveMessage = function setActiveMessage(message, $event) {
                    if ($event !== undefined) { // to fix unit test
                        var hasFunc = angular.element($event.target).attr('href') !== undefined && _.includes(angular.element($event.target).attr('href'), 'javascript'),
                            parentHasFunc = angular.element($event.target.parentElement).attr('href') !== undefined && _.includes(angular.element($event.target.parentElement).attr('href'), 'javascript');
                        if (!hasFunc && !parentHasFunc) {
                            MessageListModelService.setActiveMessage(message);
                            if (message) {
                                internal.sendMessageToDrawer(message);
                            }
                        }
                    } else {
                        MessageListModelService.setActiveMessage(message);
                        if (message) {
                            internal.sendMessageToDrawer(message);
                        }
                    }
                    if (message) {// when you close the panel, the function is called, reset the active message?
                        Tracker.events.fire('Read Message', {
                            category: Constants.CATEGORY,
                            label: message.subject,
                            dimension32: Constants.MESSAGE_LIST
                        });
                    }
                };

                /**
                 * @ngdoc method
                 * @function messageCheckboxChanged
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @param  {String} status The query for selecting the messages. Can be one of ['all', 'none', 'read', or 'unread'].
                 * @description
                 * Calls {@link MessageListModelService.selectByStatus selectByStatus} status
                 * Then calls updateButtonStates to ensure the buttons are in the correct state
                 */
                self.selectByStatus = function selectByStatus(status) {
                    var messages = MessageListModelService.selectByStatus(status),
                        total = MessageListModelService.getActiveGroup().messageList.getSize(),
                        camelCaseStatus = status.charAt(0).toUpperCase() + status.substring(1, status.length);
                    internal.updateButtonStates({
                        newCheckboxState: messages.length === 0 ?
                            Constants.CHECKBOX_STATES.NONE :
                            messages.length === total ?
                                Constants.CHECKBOX_STATES.ALL :
                                Constants.CHECKBOX_STATES.SOME
                    });
                    if (status === 'none') { // If the user selects 'None' option, then don't log number of messages.
                        Tracker.events.fire('Select ' + camelCaseStatus, {
                            category: Constants.CATEGORY,
                            dimension32: Constants.MESSAGE_LIST
                        });
                    } else { // If the user selects other options, log count of selected messages in dimension35.
                        Tracker.events.fire('Select ' + camelCaseStatus, {
                            category: Constants.CATEGORY,
                            dimension32: Constants.MESSAGE_LIST,
                            dimension35: MessageListModelService.selectMessage().length
                        });
                    }
                };

                /**
                 * @ngdoc method
                 * @function messageCheckboxChanged
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @param {Object} message the message corresponding to the altered checkbox
                 * @description
                 * Calls {@link MessageListModelService.selectMessage selectMessage} with the message and its new state
                 * Then calls updateButtonStates to ensure the buttons are in the correct state
                 */
                self.messageCheckboxChanged = function messageCheckboxChanged(message) {
                    MessageListModelService.selectMessage(message);
                    // MessageListModelService.checkboxState will be one of ['all', 'some', or 'none']
                    internal.updateButtonStates({newCheckboxState: MessageListModelService.checkboxState});
                };

                /**
                 * @ngdoc method
                 * @function checkAllChanged
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @param {boolean} allChecked the new state of the checkbox in the action bar
                 * @description
                 * Calls {@link MessageListPanelController.selectByStatus selectByStatus} with the appropriate value
                 */
                self.checkAllChanged = function checkAllChanged(allChecked) {
                    if (allChecked === true) {
                        self.selectByStatus(Constants.CHECKBOX_STATES.ALL);
                    } else {
                        self.selectByStatus(Constants.CHECKBOX_STATES.NONE);
                    }
                };

                /**
                 * @ngdoc method
                 * @function setSortOrder
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @param {number} order the new order
                 * @description
                 * cleans up the sort order and sets it
                 * will trigger internal.sortMessages() on update to the sortOptions object
                 */
                self.setSortOrder = function setSortOrder(order) {
                    self.sortOptions.order = _.parseInt(order, 10) || -1;
                    internal.sortMessages();
                };

                /**
                 * @ngdoc method
                 * @function setSortProperties
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @param {Array} sortProps An array of string sort properties
                 * @description
                 * sets the new sort property order
                 * will trigger internal.sortMessages() on update to the sortOptions object
                 */
                self.setSortProperties = function setSortProperties(sortProps) {
                    var sortProperties = sortProps;
                    sortProperties = sortProperties || Constants.DEFAULT_SORT_VALUES;
                    // if the sort property being set contains all valid parameters (as defined by validSortingParameters array), set the sortPropertiesSelected
                    if (_.intersection(sortProperties, Constants.VALID_SORT_PROPERTIES).length === sortProperties.length) {
                        self.sortOptions.properties = sortProperties;
                    } else {
                        self.sortOptions.properties = ['date', 'priority', 'from', 'subject'];
                    }
                    internal.sortMessages();
                };

                function loadCallback(state) {
                    self.isLoaded = true;
                    $timeout(function loadCallSelectInitialShade() {
                        internal.selectInitialShade(state, self.MessageListModel.model);
                        internal.sortMessages();
                    });
                }

                /**
                 * @ngdoc method
                 * @function load
                 * @param {obj} state state of the message list
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @description start to load messages
                 * @returns {promise} once the data exists
                 *
                 */
                lifecycle.load = function load(state) {
                    self.isLoaded = false;
                    return MessageListModelService.loadMessages(state)
                        .then(loadCallback.bind(self, state));
                };

                // called whenever 'real' messages are returned from the server
                function resetUI() {
                    allowSendSortEvent = false;
                    // self.setSortOrder();
                    // self.setSortProperties();
                    $timeout(function delaySortMessage() {
                        internal.sortMessages();
                        allowSendSortEvent = true;
                    });
                    internal.updateButtonStates({newCheckboxState: MessageListModelService.checkboxState || Constants.CHECKBOX_STATES.NONE});
                }

                self.refresh = function refresh() {

                    var label = 'Message List Refresh',
                        data = {
                            category: Constants.CATEGORY,
                            tags: ['refresh', 'messages', 'list']
                        };

                    self.isLoaded = false;

                    Tracker.events.fire('Refresh', {
                        category: Constants.CATEGORY,
                        dimension32: Constants.MESSAGE_LIST
                    });

                    Tracker.marks.start(label, data);

                    return MessageListModelService.refreshMessages()
                        .tap(resetUI)
                        .finally(function stopMark() {
                            Tracker.marks.stop(label, data);
                        });
                };

                self.setSelectedMessagesStatus = function setSelectedMessagesStatus(status) {
                    switch (status) {
                        case 'read':
                            MessageListModelService.markSelectedMessagesRead();
                            Tracker.events.fire('Mark As Read', {
                                category: Constants.CATEGORY,
                                // To pass unit test, same with others
                                count: MessageListModelService.selectMessage() ? MessageListModelService.selectMessage().length : 0,
                                dimension32: Constants.MESSAGE_LIST,
                                dimension35: MessageListModelService.selectMessage() ? MessageListModelService.selectMessage().length : 0
                            });
                            break;
                        case 'unread':
                            MessageListModelService.markSelectedMessagesUnread();
                            Tracker.events.fire('Mark As Unread', {
                                category: Constants.CATEGORY,
                                count: MessageListModelService.selectMessage() ? MessageListModelService.selectMessage().length : 0,
                                dimension32: Constants.MESSAGE_LIST,
                                dimension35: MessageListModelService.selectMessage() ? MessageListModelService.selectMessage().length : 0
                            });
                            break;
                        default:
                            break;
                    }
                };

                self.createPDFWithSelected = function createPDFWithSelected() {
                    Tracker.events.fire('Download Message(s)', {
                        category: Constants.CATEGORY,
                        count: MessageListModelService.selectMessage().length,
                        dimension32: Constants.MESSAGE_LIST,
                        dimension35: MessageListModelService.selectMessage().length
                    });
                    MessageListModelService.downloadSelectedMessages();
                    MessageListModelService.selectByStatus('none');
                };

                /**
                 * @ngdoc method
                 * @function deleteSelectedMessages
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @description
                 * Broadcasts toggleFlyout for messageSort flyout ID
                 */
                self.deleteSelectedMessages = function deleteSelectedMessages() {
                    var selectedMessage = MessageListModelService.selectMessage();
                    Tracker.events.fire('Delete', {
                        category: Constants.CATEGORY,
                        label: (selectedMessage && selectedMessage.length === 1) ? selectedMessage[0].subject : '',
                        count: selectedMessage ? selectedMessage.length : 0,
                        dimension32: Constants.MESSAGE_LIST,
                        dimension35: selectedMessage ? selectedMessage.length : 0
                    });
                    MessageListModelService.deleteSelectedMessages();
                };

                /**
                 * @ngdoc method
                 * @function closeMessageListPanel
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @description
                 * Closes the Message List Panel and the Message Drawer
                 */
                self.closeMessageListPanel = function closeMessageListPanel() {
                    Tracker.events.fire('Sub-Navigation', {
                        category: Constants.CATEGORY,
                        tags: ['ui', 'panel', 'button'],
                        label: 'Exit',
                        dimension32: _.get(GlobalStateService.getState(), 'app.name', 'No app selected yet.')
                    });
                    self.close();
                };

                /**
                 * @ngdoc method
                 * @function closeMessageDrawer
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @description
                 * Closes the Message Drawer when click on refresh button
                 */

                self.closeMessageDrawer = function closeMessageDrawer() {
                };

                Object.defineProperty(self, 'isLoaded', {
                    get: function get() {
                        return isLoaded;
                    },
                    set: function set(value) {
                        isLoaded = value;
                        internal.updateButtonStates({newCheckboxState: Constants.CHECKBOX_STATES.NONE});
                        if (value) {
                            resetUI();
                        }
                    }
                });

                /**
                 * @ngdoc method
                 * @function init
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @description
                 * init the controller
                 */
                lifecycle.init = function init() {

                    self.initStrings();

                    // because the UI is bound to this controller's isLoaded property, we need
                    // to make sure we stay in sync with the REAL isLoaded property from the model
                    internal.subscriptions['loaded-changed'] = MessageListDataService.on('is-loaded-changed', function onLoadChange(e) {
                        self.isLoaded = e.args[0];
                    });

                    MessageListModelService.on('messageGroups', 'active-changed', function onActiveChange(event) {
                        internal.updateActiveShade(event.args[0]);
                    });

                    $scope.$on('$destroy', internal.unload);

                    self.buttonStates = {};
                    self.MessageListModel = MessageListModelService;
                    self.isLoaded = MessageListDataService.isLoaded;

                    internal.watchers.push($scope.$watch('mlpc.MessageListModel.checkboxState', function onCheckBoxChange(newVal, oldVal) {
                        if (newVal !== oldVal) {
                            internal.updateButtonStates({newCheckboxState: newVal});
                        }
                    }));
                };

                /**
                 * @ngdoc method
                 * @function unload
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @description
                 * unload the controller
                 */
                lifecycle.unload = function unload() {
                    internal.unload();
                };

                /**
                 * @ngdoc method
                 * @function initStrings
                 * @memberOf paychex.app.landing.shared.messageList.MessageListPanelController
                 * @instance
                 * @description
                 * Initializes the locale strings
                 */
                self.initStrings = function initStrings() {
                    self.locale = {};

                    var translations = [
                        'png.core.button.more',
                        'png.core.loadingEllipsis',
                        'png.core.label.close',
                        'png.landing.messages.messages',
                        'png.landing.messages.sort',
                        'png.landing.messages.total',
                        'png.landing.messages.refresh',
                        'png.landing.messages.delete',
                        'png.landing.messages.general',
                        'png.landing.messages.markRead',
                        'png.landing.messages.markUnread',
                        'png.landing.messages.download',
                        'png.landing.messages.noMessages',
                        'png.landing.messages.flyout.ascending',
                        'png.landing.messages.flyout.descending',
                        'png.landing.messages.flyout.date',
                        'png.landing.messages.flyout.priority',
                        'png.landing.messages.flyout.from',
                        'png.landing.messages.flyout.read',
                        'png.landing.messages.flyout.unread',
                        'png.landing.messages.flyout.subject',
                        'png.landing.messages.flyout.selectAll',
                        'png.landing.messages.flyout.selectNone',
                        'png.landing.messages.flyout.selectRead',
                        'png.landing.messages.flyout.selectUnread',
                        'png.core.loadingEllipsis'
                    ];

                    TranslationService.translate(translations)
                        .then(function translateMessageListPanel(values) {
                            _.forEach(values, function initializeTranslation(value, index) {
                                self.locale[translations[index]] = value;
                            });
                            return self.locale;
                        })
                        .catch()
                        .done();
                };

                ListPanelManager.registerListPanel(self, lifecycle);
            };

        // Inject!
        Constructor.$inject = ngDependencies;

        return Constructor;

    }
);

